import styled from 'styled-components';
import { normalize, withModifiers } from 'utils/styles';
import { color, typography } from 'styles/settings';

const SLIDER_OVERFLOW = 1.3; // How wider the slider is compared to the selected option
const SPEED = 0.2;

export const Container = styled.div`
  position: relative;
  padding-bottom: ${normalize('10px')};
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  border-bottom: 1px solid ${color.neutral.grayLightest};
`;

export const Option = styled.div`
  color: inherit;
  cursor: pointer;
  vertical-align: middle;
  ${typography.font.content.semiBold};
  font-size: 24px;
  line-height: 29px;
  transition: color ${SPEED}s;

  ${withModifiers('isSelected')`
        color: ${color.brand.gold};
    `}

  @media all and (max-width: 1200px) {
    font-size: 20px;
  }
`;

export const Slider = styled.div`
  position: absolute;
  bottom: 0px;
  left: ${(props) => (props.left ? normalize(props.left) : '0px')};
  width: ${(props) =>
    props.width ? normalize(props.width * SLIDER_OVERFLOW) : '0px'};
  transform: translateX(
    ${(props) =>
      props.width
        ? normalize((props.width - props.width * SLIDER_OVERFLOW) / 2)
        : '0%'}
  );
  height: 1px;
  border-bottom: 2px solid ${color.brand.greenDark};
  transition: width ${SPEED}s, left ${SPEED}s, transform ${SPEED * 2.5}s;
`;
